import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, AndroidOutlined, DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import QRCode from 'qrcode';

const { Title } = Typography;

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState<string>('');
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const apkUrl = '/app-release.apk';
    QRCode.toDataURL(apkUrl, {
      width: 150,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    })
      .then((url) => setQrCodeUrl(url))
      .catch((err) => console.error('QR Code generation error:', err));
  }, []);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.email, values.password);
      message.success('Zalogowano pomyślnie');
      navigate('/');
    } catch (error: any) {
      message.error(error.response?.data?.message || 'Błąd logowania');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadApk = () => {
    window.open('/app-release.apk', '_blank');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f2f5' }}>
      <Card style={{ width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ marginBottom: 4 }}>Valet Admin</Title>
          <span style={{ color: '#888' }}>Zaloguj się do panelu</span>
        </div>
        <Form name="login" onFinish={onFinish} size="large">
          <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Wprowadź prawidłowy email' }]}>
            <Input prefix={<UserOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Wprowadź hasło' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Hasło" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Zaloguj
            </Button>
          </Form.Item>
        </Form>

        <div style={{ marginTop: 24, paddingTop: 24, borderTop: '1px solid #f0f0f0', textAlign: 'center' }}>
          <div style={{ marginBottom: 12 }}>
            <AndroidOutlined style={{ fontSize: 24, color: '#52c41a', marginRight: 8 }} />
            <span style={{ fontSize: 14, color: '#666' }}>Pobierz aplikację mobilną</span>
          </div>
          
          {qrCodeUrl && (
            <div style={{ marginBottom: 12 }}>
              <img 
                src={qrCodeUrl} 
                alt="QR Code" 
                style={{ border: '1px solid #d9d9d9', borderRadius: 4, padding: 8 }}
              />
            </div>
          )}
          
          <Button 
            type="default" 
            icon={<DownloadOutlined />} 
            onClick={handleDownloadApk}
            block
          >
            Pobierz APK
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
